import { render, staticRenderFns } from "./form-reset-password.vue?vue&type=template&id=3e256b8a"
import script from "./form-reset-password.vue?vue&type=script&lang=js"
export * from "./form-reset-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports